import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PackageSelectorCustomComponentDirective } from './package-selector-custom.component';

@Component({
  selector: 'sales-ui-package-revenue-header-cell',
  template: `
    <div class="title">
      {{ 'FRONTEND.SALES_UI.RETAIL_PRICE' | translate }}
    </div>
  `,
  styles: [
    `
      .title {
        text-align: right;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PackageRevenueHeaderCellComponent extends PackageSelectorCustomComponentDirective {
  constructor() {
    super();
  }
}
